export const BILLING_CYCLE_ID = {
  0: 'monthly',
  1: 'monthly',
  2: 'annual'
};

export default BILLING_CYCLE_ID;
